export enum StoreProductMediaTabs {
  all = 'all',
  custom = 'custom',
  standard = 'standard',
  old = 'old',
}

export const STANDALONE_MOCKUP_NAME = 'simple';
export const PREMIUM_SCENE_TAG = 'Premium';
export const CUSTOM_SCENE_TAG = 'Custom';
